// src/modules/notifications/api.js
//
// REST client for the CRM's own notification centre.
//
// Every call goes to the CRM API (`/api/v1/notifications`) — NOT to the old
// standalone websocket service. That service pinned one database at boot, so
// once the CRM switched clusters the bell was listing, marking read and
// clearing rows in a database nobody was writing to any more. Reading through
// the CRM API means the inbox always follows the active database.
//
// No endpoint takes a userId: the owner comes from the JWT, server-side.

import API from '../../services/api';

export async function fetchNotifications({ cursor, limit = 25, category, unreadOnly, q, type } = {}) {
  const params = { limit };
  if (cursor) params.cursor = cursor;
  if (category) params.category = category;
  if (type) params.type = type;
  if (unreadOnly) params.unreadOnly = true;
  if (q) params.q = q;
  const res = await API.get('/notifications', { params });
  return res.data; // { notifications, nextCursor, hasMore }
}

export async function fetchUnreadCount() {
  const res = await API.get('/notifications/unread-count');
  return res.data; // { total, byCategory }
}

export async function markNotificationRead(id) {
  const res = await API.post(`/notifications/${id}/read`);
  return res.data;
}

export async function markAllNotificationsRead(category = null) {
  const res = await API.post('/notifications/read-all', category ? { category } : {});
  return res.data;
}

export async function dismissNotification(id) {
  const res = await API.post(`/notifications/${id}/dismiss`);
  return res.data;
}

export async function dismissAllNotifications() {
  const res = await API.post('/notifications/dismiss-all');
  return res.data;
}

export async function fetchNotificationPreferences() {
  const res = await API.get('/notifications/preferences');
  return res.data; // { categories: [...], types: [...] }
}

export async function saveNotificationPreferences(categories) {
  const res = await API.put('/notifications/preferences', { categories });
  return res.data;
}

export async function fetchNotificationStatus() {
  const res = await API.get('/notifications/status');
  return res.data;
}
